export const monthsForLocale = (
  localeName = 'en-GB',
  monthFormat = 'short',
) => {
  const format = new Intl.DateTimeFormat(localeName, { month: monthFormat })
    .format;
  return [...Array(12).keys()].map((m) =>
    format(new Date(Date.UTC(2021, m % 12))),
  );
};

const sortByPlanData = (items) => {
  const array = [...items];
  array.sort((a, b) => {
    const aValue = parseFloat(a.name);
    const bValue = parseFloat(b.name);

    if (aValue < bValue) {
      return -1;
    }
    if (aValue > bValue) {
      return 1;
    }
    return 0;
  });
  return array;
};

export const sortByDataValue = (initDataset) => {
  let mbArr = [];
  let gbArr = [];
  let othersArr = [];

  initDataset.forEach((item) => {
    if (item.name.includes('MB')) {
      mbArr.push(item);
    } else if (item.name.includes('GB')) {
      gbArr.push(item);
    } else {
      othersArr.push(item);
    }
  });

  mbArr = sortByPlanData(mbArr);
  gbArr = sortByPlanData(gbArr);

  return [...mbArr, ...gbArr, ...othersArr];
};

export const createBarChartDataset = (data, key, value) => {
  const filteredData = data.filter((row) => row[key] === value);
  const months = monthsForLocale();

  const dataset = filteredData.map((item) => {
    return {
      label: `${months[item.month - 1]}/${item.year}`,
      value: item.count,
    };
  });

  return dataset.reverse();
};

export const createPieChartDataset = (data, plan_type, plan_carrier_type) => {
  const filteredData = data.filter(
    (row) =>
      row.plan_type === plan_type &&
      row.plan_carrier_type === plan_carrier_type,
  );

  const unMergedDataset = filteredData.map((item) => {
    return {
      name: item.plan_data_available,
      value: item.live_subscription_count,
    };
  });

  const mergedDataset = unMergedDataset.reduce((acc, item) => {
    const index = acc.findIndex((i) => i.name === item.name);
    if (index === -1) {
      acc.push(item);
    } else {
      acc[index].value += item.value;
    }
    return acc;
  }, []);

  return sortByDataValue(mergedDataset);
};
